import { z } from "zod";

// --- Category schemas ---

export const serviceCategorySchema = z.object({
  id: z.string(),
  name: z.string(),
  sortOrder: z.number().int(),
});

export const serviceCategoriesResponseSchema = z.object({
  items: z.array(serviceCategorySchema),
});

export const serviceCategoriesQuerySchema = z.object({
  salonId: z.string().min(1),
});

// --- Category CRUD (authenticated) ---

export const serviceCategoryCreateSchema = z.object({
  salonId: z.string().min(1),
  name: z.string().min(1).max(60),
});

export const serviceCategoryUpdateSchema = z.object({
  id: z.string().min(1),
  salonId: z.string().min(1),
  name: z.string().min(1).max(60).optional(),
  sortOrder: z.number().int().min(0).optional(),
});

export const serviceCategoryDeleteSchema = z.object({
  id: z.string().min(1),
  salonId: z.string().min(1),
});

export const serviceCategoryReorderSchema = z.object({
  salonId: z.string().min(1),
  /** Ordered list of category IDs — the index becomes the new sortOrder. */
  order: z.array(z.string().min(1)).min(1),
});

export const serviceCategoryMutationResponseSchema = z.object({
  category: serviceCategorySchema,
});

export const serviceCategoryDeleteResponseSchema = z.object({
  deleted: z.boolean(),
});

export const serviceCategoryReorderResponseSchema = z.object({
  items: z.array(serviceCategorySchema),
});

// --- Inferred types ---

export type ServiceCategory = z.infer<typeof serviceCategorySchema>;
export type ServiceCategoriesResponse = z.infer<
  typeof serviceCategoriesResponseSchema
>;
export type ServiceCategoriesQuery = z.infer<
  typeof serviceCategoriesQuerySchema
>;
export type ServiceCategoryCreate = z.infer<typeof serviceCategoryCreateSchema>;
export type ServiceCategoryUpdate = z.infer<typeof serviceCategoryUpdateSchema>;
export type ServiceCategoryDelete = z.infer<typeof serviceCategoryDeleteSchema>;
export type ServiceCategoryReorder = z.infer<
  typeof serviceCategoryReorderSchema
>;
export type ServiceCategoryMutationResponse = z.infer<
  typeof serviceCategoryMutationResponseSchema
>;
export type ServiceCategoryDeleteResponse = z.infer<
  typeof serviceCategoryDeleteResponseSchema
>;
export type ServiceCategoryReorderResponse = z.infer<
  typeof serviceCategoryReorderResponseSchema
>;
